import { render } from "./awards.vue?vue&type=template&id=9e6636a6&scoped=true"
import script from "./awards.vue?vue&type=script&lang=js"
export * from "./awards.vue?vue&type=script&lang=js"

import "./awards.vue?vue&type=style&index=0&id=9e6636a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6636a6"]])

export default __exports__